<template>
    <div class="shop">
        <div class="shop_category_filter-section">
            <shop-category-filter/>
        </div>

        <div class="shop_sale_slider-section" v-if="this.$store.getters.shopSales.length !== 0">
            <shop-sale-slider/>
        </div>

        <div class="shop_items-section">
            <shop-items/>
        </div>
    </div>
</template>

<script>
    import ShopCategoryFilter from "../components/shop/ShopCategoryFilter";
    import ShopSaleSlider from "../components/shop/ShopSaleSlider";
    import ShopItems from "../components/shop/ShopItems";

    export default {
        name: 'Shop',
        components: {ShopItems, ShopCategoryFilter, ShopSaleSlider},
        created() {
            const scheduleId = this.$route.params.scheduleId || null;

            if (this.$store.getters.shopSales.length === 0){
              this.$store.dispatch('loadShopSales', scheduleId);
            }

            if (this.$store.getters.shopMainCategories.length === 0){
              this.$store.dispatch('loadShopMainCategories', scheduleId);
            }
        },
        data() {
            return {

            }
        },
        methods: {
        },
    }
</script>
